(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const centerActiveSubcollection = () => {
    const list = document.querySelector('.ourooh-subcollection-nav__list');
    const activeLink = list?.querySelector('[aria-current="page"]');

    if (!list || !activeLink || list.scrollWidth <= list.clientWidth) return;

    const centeredPosition = activeLink.offsetLeft - (list.clientWidth - activeLink.offsetWidth) / 2;
    list.scrollLeft = Math.max(0, centeredPosition);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(centerActiveSubcollection), { once: true });
  } else {
    requestAnimationFrame(centerActiveSubcollection);
  }

  // Shortens a long collection description, with Read more and Read less. The full text is
  // always in the page, so search engines read all of it.
  //
  // CSS cuts the text to a whole number of lines. Beside a photograph on desktop the
  // description takes the height left in the words column, and this works out how many lines
  // fit, so the text ends level with Shop by type or the photograph's bottom edge. The button
  // appears only once the text has been measured as running past its lines. Heights are read
  // from layout rather than the screen, so a page transition's transform cannot skew them.
  //
  // The listeners sit on the element itself, so they survive the section morph that runs
  // when a shopper moves between subcollections. The morph keeps this element but resets its
  // attributes to the server's markup, which drops data-measured. That is the cue to measure
  // the new text.
  class OuroohCollectionDescription extends HTMLElement {
    #resizeObserver = new ResizeObserver(() => this.#update());
    #mutationObserver = new MutationObserver(() => {
      if (!this.hasAttribute('data-measured')) this.#observe();
    });

    connectedCallback() {
      this.addEventListener('click', this.#handleClick);
      this.addEventListener('focusin', this.#handleFocus);
      this.addEventListener('scroll', this.#handleScroll, true);
      this.#mutationObserver.observe(this, { attributes: true, attributeFilter: ['data-shortened', 'data-measured'] });
      this.#observe();
      document.fonts?.ready.then(this.#updateLater);
      window.addEventListener('load', this.#updateLater);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick);
      this.removeEventListener('focusin', this.#handleFocus);
      this.removeEventListener('scroll', this.#handleScroll, true);
      window.removeEventListener('load', this.#updateLater);
      this.#mutationObserver.disconnect();
      this.#resizeObserver.disconnect();
    }

    #observe() {
      const text = this.#text;
      this.#resizeObserver.disconnect();
      if (!this.hasAttribute('data-shortened') || !text) return;

      this.#resizeObserver.observe(this);
      this.#resizeObserver.observe(text);
    }

    get #text() {
      return this.querySelector('.ourooh-collection-intro__text');
    }

    get #button() {
      return this.querySelector('.ourooh-collection-intro__more');
    }

    #updateLater = () => this.#update();

    #update() {
      const text = this.#text;
      if (!this.hasAttribute('data-shortened') || this.hasAttribute('expanded') || !text) return;

      let line = '';
      let lines = '';

      // Beside a photograph the lines are counted to fill the space. When the text runs on,
      // the line spacing gives by up to 6% so the last line ends on the photograph's edge
      // rather than short of it.
      if (getComputedStyle(this).getPropertyValue('--ourooh-description-fill').trim() === '1') {
        this.style.removeProperty('--ourooh-description-line');
        this.style.removeProperty('--ourooh-description-lines');

        const base = parseFloat(getComputedStyle(text).lineHeight);
        const space = this.offsetHeight;

        if (base > 0) {
          lines = String(Math.max(3, Math.floor((space + 0.5) / base)));
          this.style.setProperty('--ourooh-description-lines', lines);

          const exact = Math.max(3, Math.round(space / base));
          if (text.scrollHeight > text.clientHeight + 1 && Math.abs(space / exact / base - 1) <= 0.06) {
            line = `${space / exact}px`;
            lines = String(exact);
          }
        }
      }

      this.#setProperty('--ourooh-description-line', line);
      this.#setProperty('--ourooh-description-lines', lines);

      text.scrollTop = 0;
      this.toggleAttribute('data-fits', text.scrollHeight <= text.clientHeight + 1);
      this.toggleAttribute('data-measured', true);
    }

    #setProperty(name, value) {
      if (!value) {
        this.style.removeProperty(name);
      } else if (this.style.getPropertyValue(name) !== value) {
        this.style.setProperty(name, value);
      }
    }

    #setExpanded(expanded) {
      const button = this.#button;
      this.toggleAttribute('expanded', expanded);

      if (button instanceof HTMLButtonElement) {
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
      }

      if (!expanded) this.#update();
    }

    #handleClick = (event) => {
      const button = event.target instanceof Element ? event.target.closest('.ourooh-collection-intro__more') : null;
      if (!(button instanceof HTMLButtonElement)) return;

      this.#setExpanded(!this.hasAttribute('expanded'));
    };

    // A link below the last line shown opens the description, so keyboard focus never lands
    // on text the shopper cannot see.
    #handleFocus = (event) => {
      const text = this.#text;
      const target = event.target;
      if (!text || !(target instanceof Element) || !text.contains(target)) return;
      if (this.hasAttribute('expanded') || !this.hasAttribute('data-measured') || this.hasAttribute('data-fits')) return;

      const hidden = text.scrollTop > 0 || target.getBoundingClientRect().bottom > text.getBoundingClientRect().bottom + 1;
      if (hidden) this.#setExpanded(true);
      text.scrollTop = 0;
    };

    // Find in page can scroll the shortened text to show a match. That opens it too, rather
    // than leaving the box showing lines from the middle.
    #handleScroll = (event) => {
      const text = this.#text;
      if (event.target !== text || text.scrollTop === 0 || this.hasAttribute('expanded')) return;

      this.#setExpanded(true);
      text.scrollTop = 0;
    };
  }

  if (!customElements.get('ourooh-collection-description')) {
    customElements.define('ourooh-collection-description', OuroohCollectionDescription);
  }

  } catch(e) { console.error(e); }
})();
})();
